<h1 class="title">Calendars</h1>

<mat-divider></mat-divider>

<div class="calendars">
  <div class="calendar" *ngFor="let calendar of calendars">
    <div class="toggle" (click)="toggleCalendarVisibility(calendar)">
      <mat-icon
        class="visibility"
        [ngClass]="'text-' + calendar.color + '-500'"
        [svgIcon]="calendar.visible ? 'check_box' : 'check_box_outline_blank'"
      ></mat-icon>

      <span class="title">
        {{ calendar.title }}
      </span>
    </div>
    <mat-icon class="edit" [svgIcon]="'edit'" (click)="openEditPanel(calendar)"></mat-icon>
  </div>
</div>

<!-- Edit panel -->
<ng-template #editPanel>
  <h4 class="title">Edit calendar</h4>
  <div class="row">
    <mat-form-field class="treo-mat-no-subscript">
      <input matInput [(ngModel)]="calendar.title" [placeholder]="'Title'" required />
      <mat-select
        class="calendar-color-selector"
        [(value)]="calendar.color"
        [panelClass]="'calendar-sidebar-calendar-edit-panel-color-select-panel'"
        [disableOptionCentering]="true"
        matPrefix
      >
        <mat-select-trigger>
          <mat-icon [ngClass]="'text-' + calendar.color + '-500'" [svgIcon]="'color_lens'"></mat-icon>
        </mat-select-trigger>
        <div class="color-box-title">Calendar color</div>
        <div class="color-box-container">
          <mat-option *ngFor="let color of calendarColors" [value]="color" #matOption="matOption">
            <mat-icon [ngClass]="color" *ngIf="matOption.selected" [svgIcon]="'check'"></mat-icon>
            <span class="color-box" [ngClass]="color"></span>
          </mat-option>
        </div>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="actions">
    <button mat-button (click)="closeEditPanel()">Cancel</button>
    <button mat-flat-button [color]="'primary'" [disabled]="!calendar.title" (click)="saveCalendar(calendar)">
      Update
    </button>
  </div>
</ng-template>
